import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Trust } from "@/components/Trust";
import { Services } from "@/components/Services";
import { Coverage } from "@/components/Coverage";
import { Realizations } from "@/components/Realizations";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

function App() {
  return (
    <div className="App min-h-screen bg-white antialiased overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <Trust />
        <Services />
        <Realizations />
        <Coverage />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
